import React from "react";
import { inject, observer } from "mobx-react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import menu from "../../data/menu";

const LogInfo = inject("commonStore")(
  observer((props) => {
    const history = useHistory();
    const logOut = () => {
      history.push("/");
      props.commonStore.setAppLoaded(2);
      for (let i in menu) {
        //로그아웃하고 재로그인하면 메뉴 겹치는 버그 막아주는 역할
        menu[i].color = "#A1A1B1";
        menu[i].border = "#E5E5E5";
      }
    };
    return (
      <Box>
        <span>
          <span>{localStorage.getItem("name")}</span>
          <span>님</span>
        </span>
        <span onClick={logOut}>
          <img src={require("../../styles/img/logOut.png")} alt="logout" />
          <span>Log Out</span>
        </span>
      </Box>
    );
  })
);

const Box = styled.div`
  font-size: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  & img {
    width: 20%;
    margin-right: 10px;
  }

  & > span:first-child {
    margin-right: 20px;
    > span:first-child {
      font-weight: bold;
    }
  }

  & > span:last-child {
    cursor: pointer;
    > span {
      color: #1d83e9;
    }
  }
`;

export default LogInfo;
